import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from "../contexts/auth";
import {  getOrdersTotalURL } from '../utils/api';

const useGetOrderTotal = ({ 
        type,
        customerId = undefined,
        setErrors
    }) => {
        
    const { auth } = useAuth();
    const [ gettingOrderTotal, setGettingOrderTotal ] = useState(false);
    const [ orderTotal, setOrderTotal ] = useState(0);
    const [ gettingOrderTotalReqSuccess, setGettingOrderTotalReqSuccess ] = useState(false);
    
    useEffect(() => {

        if (gettingOrderTotal) {
            axios.get(getOrdersTotalURL,
            {
                headers: {
                    Authorization: `Bearer ${auth.authToken}`
                },
                params: {
                    type,
                    customerId,
                }
            }).then(result => {
                setGettingOrderTotal(false);
                if (result.status === 200) {
                    const data = result.data.data;
                    setGettingOrderTotalReqSuccess(true);
                    setOrderTotal(data);         
                } else {
                    // console.log(result.data.errors);
                    if (setErrors) {
                        setErrors(result.data.errors);
                    }
                    setGettingOrderTotalReqSuccess(false);
                    // setOperatorAddErrors(result.data.errors);
                }
            }).catch(e => {
                if (e.response === undefined) {
                    // console.log(e);
                    if (setErrors) {
                        setErrors(['Could not connect to server']);
                    }
                    // setOperatorAddErrors(['Could not connect to server!'])
                } else {
                    // console.log(e.response.data.errors);
                    // setOperatorAddErrors(e.response.data.errors)
                    if (setErrors) {
                        setErrors([e.response.data.errors]);
                    }
                }
                setGettingOrderTotalReqSuccess(false);
                setGettingOrderTotal(false);
            });
        }
    }, [gettingOrderTotal]);

    return { orderTotal, gettingOrderTotal, setGettingOrderTotal, gettingOrderTotalReqSuccess };
}

export default useGetOrderTotal;